/* Marka katmanı JS: beden hesaplayıcı, dialog, giriş animasyonu. Bağımlılık yok. */
(() => {
  // --- Bedenimi bul ---------------------------------------------------------
  class PcSizeFinder extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.result = this.querySelector('.pc-finder__result');
      try {
        this.charts = JSON.parse(this.querySelector('[data-pc-charts]').textContent);
      } catch (e) {
        this.charts = [];
      }
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.calculate();
      });
    }

    parse(name) {
      const raw = this.form.elements[name]?.value ?? '';
      const value = parseFloat(String(raw).replace(',', '.'));
      return Number.isFinite(value) ? value : null;
    }

    show(message, state) {
      this.result.textContent = message;
      this.result.dataset.state = state;
      this.result.hidden = false;
    }

    calculate() {
      const fitIndex = parseInt(this.form.elements.fit?.value ?? '0', 10) || 0;
      const rows = this.charts[fitIndex]?.rows ?? [];
      const weight = this.parse('weight');
      const chest = this.parse('chest');
      if (weight === null && chest === null) return this.show(this.dataset.msgEmpty, 'warn');

      const byWeight = weight === null ? -1 : rows.findIndex((r) => weight <= Number(r.weight_max));
      const byChest = chest === null ? -1 : rows.findIndex((r) => chest <= Number(r.chest_max));
      const tooSmall =
        (weight !== null && rows[0] && weight < Number(rows[0].weight_min) * 0.6) ||
        (chest !== null && rows[0] && chest < Number(rows[0].chest_min) - 6);
      const missing = (weight !== null && byWeight === -1) || (chest !== null && byChest === -1);
      if (missing || tooSmall) return this.show(this.dataset.msgNone, 'warn');

      const index = Math.max(byWeight, byChest);
      const size = rows[index].size;
      const between = byWeight !== -1 && byChest !== -1 && byWeight !== byChest;
      this.show((between ? this.dataset.msgBetween : this.dataset.msgResult).replace('{size}', size), 'ok');
      this.dispatchEvent(new CustomEvent('pc:size-recommended', { bubbles: true, detail: { size } }));
    }
  }
  if (!customElements.get('pc-size-finder')) customElements.define('pc-size-finder', PcSizeFinder);

  // --- Dialog ---------------------------------------------------------------
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pc-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.pcDialogOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-pc-dialog-close]');
    if (closer) return closer.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('pc-dialog')) event.target.close();
  });

  // Bize ulaşın: form gönderildikten sonra sayfa yenilenir; sonucu görsün diye pencereyi yeniden aç.
  const contactDialog = document.getElementById('pc-contact-dialog');
  if (contactDialog && contactDialog.querySelector('[data-pc-contact-posted]') && typeof contactDialog.showModal === 'function') {
    contactDialog.showModal();
  }

  // --- Ülke/bölge seçici (footer) ---------------------------------------------
  // Seçim değişince localization formu gönderilir; Shopify ilgili pazarın adresine (ör. /en-gb) yönlendirir.
  document.addEventListener('change', (event) => {
    if (event.target.matches?.('[data-pc-country]')) event.target.form?.submit();
  });

  // --- Giriş animasyonu (bir kez, reduced-motion'da kapalı) -------------------
  const targets = document.querySelectorAll('[data-pc-reveal]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Sessiz döngü videolar (hero + editoryal split) -------------------------
  // Markup'ta autoplay YOK, preload=none var: görünür olanı biz play() ederiz. Böylece
  // masaüstünde gizli (display:none) mobil hero videosu hiç indirilmez; IntersectionObserver
  // gizli öğeyi "kesişmiyor" sayar. reduced-motion'da hiç oynatılmaz, poster kalır.
  const lazyVideos = document.querySelectorAll('video[data-pc-lazy-video]');
  if (reduce) {
    lazyVideos.forEach((v) => v.pause());
  } else if (lazyVideos.length && 'IntersectionObserver' in window) {
    const vio = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const v = entry.target;
          if (entry.isIntersecting) v.play().catch(() => {});
          else v.pause();
        });
      },
      { rootMargin: '200px 0px' }
    );
    lazyVideos.forEach((v) => vio.observe(v));
  } else {
    lazyVideos.forEach((v) => v.play().catch(() => {}));
  }
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    targets.forEach((el) => io.observe(el));
  }
})();
